import { gql } from '@apollo/client';

export const INVOICE_FIELDS = gql`
  fragment InvoiceFields on Invoice {
    billingId
    clientId
    createdDate
    invoiceDueDate
    invoiceId
    status
  }
`;
